/**
 * @module app.shared
 */

import { IApiQueryResults, IApiActionResults } from './api/api-types';

// obsolete exports
export * from './api/api';
export * from './api/api-action';
export * from './api/api-query';
export * from './api/api-filters';
export * from './api/api-results';
export * from './session/session';

// obsolete alias
export type ApiQueryResponse<T> = IApiQueryResults<T>;

// obsolete alias
export type ApiPostResponse = IApiActionResults;

// obsolete type
export enum ApiQueryFilterGroupOperator {
    And = 'and',
    Or = 'or'
}

// obsolete type
export enum ApiQueryStringFilterWildcard {
    Equals = 'eq',
    StartsWith = 'startsWith',
    Contains = 'contains',
    EndsWith = 'endsWith'
}

// obsolete type
export enum ApiQueryDateTimeFilterWildcard {
    GreaterThan = 'gt',
    LessThan = 'lt',
    GreaterThanOrEqualTo = 'gte',
    LessThanOrEqualTo = 'lte'
}

// obsolete type
export interface ApiQueryIdentifierFilterOptions {
    ignoreNullValue?: boolean;
    not?: boolean;
}

// obsolete type
export interface ApiQueryStringFilterOptions {
    ignoreNullValue?: boolean;
    not?: boolean;
    wildcard?: ApiQueryStringFilterWildcard;
}

// obsolete type
export interface ApiQueryDateTimeFilterOptions {
    ignoreNullValue?: boolean;
    not?: boolean;
    wildcard?: ApiQueryDateTimeFilterWildcard;
}

// obsolete type
export enum ApiQueryCurrentFilterIdentifier {
    User = 'user.id',
    Application = 'application.id',
    UserRelatedModel = '$context.id'
}

// obsolete type
export enum ApiQueryState {
    Inactive = 'inactive',
    InactiveOnly = 'inactiveOnly',
    Active = 'active'
}

